/**
 * Source of truth for all blog posts.
 * Add new entries here when you publish — each becomes a route /blog/:slug
 * and shows up on the index page.
 */
export const POSTS = [
  {
    slug: "best-ethnic-wear-for-office-2026",
    title: "Best Ethnic Wear for Office in 2026 — Look Elegant, Feel Comfortable",
    excerpt:
      "Indian workplaces have quietly shifted. The blazer-and-trousers uniform is giving way to something more personal — and more comfortable. Here are five office ethnic styles for 2026.",
    category: "Style Guide",
    author: "By StyleMe",
    date: "June 2026",
    hero: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=1600&q=80",
    tags: ["office", "ethnic", "kurta", "saree", "co-ord"],
  },
];

export const getPost = (slug) => POSTS.find((p) => p.slug === slug);
